import _ from 'lodash'

export default invoiceCtrl

/** @ngInject */
function invoiceCtrl($scope, $q, $uibModal, $rootScope, ErrorCatcher, Contract, ContractStatus,
                     invoices, userInfo, userAction, transaction) {
    $scope.data = invoices
    $scope.userInfo = userInfo
    $scope.userAction = userAction
    $scope.transation = transaction

    $scope.isSelectedContractActive = () => userInfo.contractSelected.status !== ContractStatus.resilie
    $scope.isUserContractActive = () => userInfo.contractSelected.status === ContractStatus.enService
    $scope.isSelectedContractHasPot = () => userInfo.contractSelected.providerOffer.has_pot

    $scope.updateInvoices = () =>
        Contract.getInvoices({ id: userInfo.contractSelected.id }).$promise
        .catch((error) => {
            ErrorCatcher.catchError(error)
            return $q.resolve({ currentSituation: {}, invoices: [] })
        }).then((invoicesData) => {
            $scope.data = invoicesData
        })


    const openTransactionStatusPopup = function () {
        if ($rootScope.dataFeature.invoiceRegulateByCreditCard && _.isString(transaction.transactionStatus)) {
            $uibModal.open({
                animation: true,
                template: require('./modal/modal-transaction-status.jade')(),
                resolve: {
                    transaction: () => $scope.transation,
                },
                controller($scope, $uibModalInstance, transaction) {
                    $scope.transaction = transaction
                    $scope.isTransationSuccess = transaction.transactionStatus === 'success'
                    $scope.close = () => $uibModalInstance.dismiss()
                },
            })
        }
    }

    const activate = () => openTransactionStatusPopup()

    activate()
}



// WEBPACK FOOTER //
// ./src/states/invoice/invoice.js